import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { usePartyAuth } from '../contexts/PartyAuthContext';
import client from '../api/client';

export default function PartyDashboard() {
  const { party, logout } = usePartyAuth();
  const navigate = useNavigate();
  const [partyInfo, setPartyInfo] = useState(null);
  const [voteData, setVoteData] = useState(null);
  const [allParties, setAllParties] = useState([]);
  const [liveVotes, setLiveVotes] = useState(null);

  useEffect(() => {
    if (!party) { navigate('/party/login'); return; }

    client.get('/party/me').then(res => setPartyInfo(res.data)).catch(() => {});
    client.get('/party/votes').then(res => {
      setVoteData(res.data);
      setLiveVotes(res.data.total_votes);
    }).catch(() => {});
    client.get('/results').then(res => setAllParties(res.data.parties)).catch(() => {});

    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const socket = new WebSocket(`${wsProtocol}//${window.location.host}/ws`);

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.type === 'vote_update') {
        setLiveVotes(data.total_votes);
      }
    };

    return () => {
      socket.close();
    };
  }, [party, navigate]);

  const handleLogout = () => {
    logout();
    navigate('/party/login');
  };

  if (!party) return null;

  const rank = allParties.findIndex(p => p.name === partyInfo?.name) + 1;
  const totalVotes = allParties.reduce((sum, p) => sum + p.vote_count, 0);
  const myVotes = partyInfo?.vote_count || 0;
  const percentage = totalVotes > 0 ? ((myVotes / totalVotes) * 100).toFixed(1) : '0.0';

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>{partyInfo?.name || party.name} Dashboard</h1>
        <button onClick={handleLogout} className="btn-secondary">Logout</button>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <h3>{liveVotes !== null ? liveVotes : myVotes}</h3>
          <p>Total Votes (Live)</p>
        </div>
        <div className="stat-card">
          <h3>{percentage}%</h3>
          <p>Vote Share</p>
        </div>
        <div className="stat-card">
          <h3>#{rank || '—'}</h3>
          <p>Current Rank</p>
        </div>
      </div>

      <div className="nav-grid">
        <Link to="/party/candidates" className="nav-card">
          <h3>Candidates</h3>
          <p>View candidate rankings by constituency</p>
        </Link>
        <Link to="/party/analytics" className="nav-card">
          <h3>Analytics</h3>
          <p>Vote distribution by constituency</p>
        </Link>
      </div>
    </div>
  );
}
